import { useEffect } from 'react';
import { withRouter } from 'react-router';

const NAVBAR_SCROLL_OFFSET = 115;

export function getLocationFragment(fragment: string) {
  return fragment ? fragment.slice(1) : '';
}

export function scrollToAnchor(element: Element | null) {
  if (!element) return;

  // this checks for incompatibility with scrollToOptions (IE11/Safari)
  if (!('scrollBehavior' in document.documentElement.style)) {
    element.scrollIntoView();
    window.scrollBy(0, -NAVBAR_SCROLL_OFFSET);
    return;
  }

  // for browsers that support scrollToOptions
  const elementPosition = element.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
  const offsetPosition = elementPosition - NAVBAR_SCROLL_OFFSET;

  // using scrollTo instead of scrollIntoView because we need an offset
  // using scrollBy can interrupt the smooth scrolling from scrollIntoView
  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
}

const ScrollHandler = ({ location }: any) => {
  useEffect(() => {
    const hash = getLocationFragment(location.hash);

    const element = document.getElementById(hash);

    scrollToAnchor(element);
  });

  return null;
};

const Routed = withRouter(ScrollHandler);

export {
  Routed as ScrollHandler
};
